<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/common/logo.svg" alt="Logo">
			</header>

			<div class="main">

				<div class="mr-potty">
					<img src="assets/images/common/confounded_mr_potty.svg" alt="Confounded Mr Potty">
				</div>

				<div class="mr-potty-hands">
					<img class="mr-potty-invisible" src="assets/images/common/confounded_mr_potty.svg"
						alt="Confounded Mr Potty">
					<img class="left-arm" src="assets/images/common/left_arm_confounded.svg" alt="Left Arm">
					<img class="right-arm" src="assets/images/common/right_arm_confounded.svg" alt="Right Arm">
				</div>

				<div class="main-content">

					<h2 class="title">The Pain Meter</h2>

					<app-progress-bar [activeStep]="activeStep"></app-progress-bar>

					<div class="emoji-wrapper">
						<div class="emoji-block">
							<img class="cloud" src="assets/images/pain-meter/cloud.svg" alt="Cloud">
							<img class="emoji" [src]="basePathToEmoji + currentEmojiFileName" alt="Emoji">
						</div>

						<app-range #rangeComponent (currentEmoji)="setCurrentEmoji($event)"></app-range>
					</div>

				</div>

				<app-navigation-buttons 
					#navigationButtons 
					[nextButtonText]="nextButtonText"
					[isSkipButtonHidden]="true"
					[twoButtonsShowing]="true"
					[isSkipDisplayed]="nextButtonText === 'skip'"
					(click)="savePainMeterMetadata($event)">
				</app-navigation-buttons>
			</div>

		</div>
	</div>
</ion-content>
